import { render, staticRenderFns } from "./base-button.vue?vue&type=template&id=932ce82a&scoped=true&"
import script from "./base-button.vue?vue&type=script&lang=ts&"
export * from "./base-button.vue?vue&type=script&lang=ts&"
import style0 from "./base-button.vue?vue&type=style&index=0&id=932ce82a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "932ce82a",
  null
  
)

export default component.exports